import React from 'react';

import type { IEditorPreloader } from './types.ts';

const noop: (config: IEditorPreloader) => React.ReactNode = () => null;

export const EditContentButtonPreloaderContext: React.Context<
	(config: IEditorPreloader) => React.ReactNode
> = React.createContext(noop);

EditContentButtonPreloaderContext.displayName = 'EditContentButtonPreloaderContext';
